import { render, staticRenderFns } from "./RoleGroup.vue?vue&type=template&id=408ad720"
import script from "./RoleGroup.vue?vue&type=script&lang=ts"
export * from "./RoleGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports